import {Dialog, Transition} from "@headlessui/react";
import React, {Component, Fragment} from "react";
import {fieldsToHtml, scrollErrorIntoView} from "../../util/util";
import {FieldsManager} from "../../data/services/fields";

export default class ModalViewResource extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fields: this.props.fields
        }

        this.cancelButtonRef = React.createRef();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((prevProps.visible !== this.props.visible) && !!this.props.visible) {
            this.setState({
                fields: this.props.fields
            })
        }
    }

    handleInputChange = (name, value) => {
        const fields = this.props.handleInputChange
            ? this.props.handleInputChange(this.state.fields, name, value)
            : FieldsManager.updateField(this.state.fields, name, value);

        this.setState({fields: fields});
    };

    getValidFields = () => {
        let validatedFields = FieldsManager.validateFields(this.state.fields);
        validatedFields = !!this.props.validateFields ? this.props.validateFields(validatedFields) : validatedFields;

        if (FieldsManager.checkFieldsForErrors(validatedFields)) {
            return FieldsManager.getFieldKeyValues(validatedFields);
        } else {
            this.setState({fields: validatedFields});

            scrollErrorIntoView(validatedFields);
        }
    }

    render() {
        const {onSubmit, onClose, visible, translate, title, className, metadata, onCustomActions} = this.props;

        const addClass = className ? " " + className : ""

        const fieldsHtml = fieldsToHtml(Object.values(Object.assign({}, this.state.fields)), translate, this.handleInputChange, metadata);

        return (
            <Transition show={visible} as={Fragment}>
                <Dialog
                    as="div"
                    id="modal"
                    className="fixed inset-0 z-20 overflow-y-auto"
                    initialFocus={this.cancelButtonRef}
                    static
                    open={visible}
                    onClose={onClose}
                >
                    <div className="min-h-screen px-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30 transition-opacity"/>
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span
                            className="inline-block h-screen align-middle"
                            aria-hidden="true"
                        >
                        &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            {/*removed class because of the date popups being cut off: overflow-hidden*/}
                            <div
                                className={"theme-dark-popup inline-block w-full text-left align-middle transition-all transform bg-inverse shadow-xl rounded-2xl" + addClass}>

                                <div className="px-4 py-5 sm:px-6">
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">{this.props.title}</h3>
                                    {this.props.subTitle && (
                                        <p className="mt-1 max-w-2xl text-sm text-gray-500">{this.props.subTitle}</p>
                                    )}
                                </div>

                                <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
                                    <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                                        {fieldsHtml}
                                    </dl>
                                </div>

                                <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
                                    <div className="flex justify-end">
                                        {!!onCustomActions && onCustomActions()}

                                        <button type="button"
                                                className="btn btn-outline focus:ring-offset-inverse hover:cursor-pointer"
                                                onClick={(e) => onClose()}
                                        >
                                            {translate("btn.close")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        );
    }
}
